import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useLoanEbarimtsList() {
  // Use toast
  const toast = useToast()

  const refReportDataTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'due_date', sortable: true, label: 'Хугацаа' },
    { key: 'customer_id', sortable: true, label: 'Харилцагчийн ID' },
    { key: 'loan_account_id', sortable: true, label: 'Зээлийн дансны ID' },
    { key: 'trigger_type', sortable: true, label: 'Төрөл' },
    { key: 'total_amount', sortable: true, label: 'Нийт дүн' },
    { key: 'status', sortable: true, label: 'Төлөв' },
    { key: 'ddtd', sortable: true, label: 'ДДТД' },
    { key: 'error_code', sortable: true, label: 'Алдааны код' },
    { key: 'actions', sortable: false, label: 'Үйлдэл' },
  ]
  const perPage = ref(10)
  const totalEntries = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('due_date')
  const isSortDirDesc = ref(true)
  const loanEbarimtFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refReportDataTable.value ? refReportDataTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    }
  })

  const refetchData = () => {
    refReportDataTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, loanEbarimtFilter], () => {
    refetchData()
  })

  const fetchLoanEbarimtData = (ctx, callback) => {
    const filter = loanEbarimtFilter.value || {}
    const payload = {
      limit: perPage.value,
      offset: perPage.value * (currentPage.value - 1),
    }
    if (filter.due_date_from) payload.due_date_from = filter.due_date_from
    if (filter.due_date_to) payload.due_date_to = filter.due_date_to
    if (filter.customer_id) payload.customer_id = filter.customer_id
    if (filter.loan_account_id) payload.loan_account_id = filter.loan_account_id
    if (filter.status) payload.status = filter.status
    if (filter.trigger_type) payload.trigger_type = filter.trigger_type

    store
      .dispatch('app-loan-ebarimt/fetchLoanEbarimtRegistry', payload)
      .then(response => {
        const { items, total } = response.data
        callback(items)
        totalEntries.value = total
      })
      .catch(() => {
        callback([])
        toast({
          component: ToastificationContent,
          props: {
            title: 'И-баримт бүртгэл татахад алдаа гарлаа',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const resolveStatusVariant = status => {
    const normalized = (status || '').toLowerCase()
    if (normalized === 'sent' || normalized === 'success') return 'success'
    if (normalized === 'pending') return 'warning'
    if (normalized === 'failed' || normalized === 'error') return 'danger'
    return 'primary'
  }

  const resolveTriggerTypeLabel = triggerType => {
    if (triggerType === 'PAYMENT') return 'Төлөлт'
    if (triggerType === 'MONTH_END') return 'Сарын сүүл'
    return triggerType
  }

  return {
    fetchLoanEbarimtData,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refReportDataTable,
    refetchData,

    resolveStatusVariant,
    resolveTriggerTypeLabel,

    // Extra Filters
    loanEbarimtFilter,
  }
}
